export default "__VITE_ASSET__DKnIqZm3__"